import { css } from 'styled-components';

const customFontsUrl = process.env.REACT_APP_PROXY_URL;

export default css`
  @import url('${customFontsUrl}/user/fonts');
`;
